import React, { useCallback, useEffect, useState } from 'react'
import BreadCrumbBar from '../../common/breadCrumbBar/BreadCrumbBar'
import '../../css/common.css'
import { DataGrid } from '@mui/x-data-grid';
import SearchBar from '../../common/searchBar/SearchBar';
import ExportExcel from '../../common/excel/ExportExcel';
import moment from 'moment';
import { ApiService } from '../../services/apiService';
import { CircularProgress } from '@mui/material';
import Warning from '../../common/alert/Warning';
import { dateFormat } from '../../common';

export default function UserActionList() {
	const [rowData, setRowData] = useState([]);
	let params = "";
	const [containData, setContainData] = useState({});
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [rowCount, setRowCount] = useState(0);
	const [excelClick, setExcelClick] = useState(false);
	const [excelList, setExcelList] = useState([]);
	const [totalLength, setTotalLength] = useState(0);
	const [loading, setLoading] = useState(false);
	const [openWarning, setOpenWarning] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [paginationModel, setPaginationModel] = useState({
		page: 0,
		pageSize: 30,
	});

	const closeWarning = (data) => {
		setOpenWarning(data);
	}

	const xlsxHeader = {
		header: [
			'사용자아이디', '작업내역', '작업일자'
		]
	}

	const today = moment().format('YYYY-MM-DD');
	const xlsxFileName = "사용자이력리스트_" + today;

	const getExcelData = async () => {
    setExcelClick(false);
    setLoading(true);
    params = `limit=${totalLength}`;

		try {
			const response = await ApiService.getUserAction(params);
			const excelRows = response.data.datas.map((data) => {
        data.created = dateFormat(new Date(data.created));
        data.name = data.body.name;
        return {
          사용자아이디: data.user_id,
          // '이름' : data.name,
          작업내역: data.action,
          작업일자: data.created,
        };
      });
			setExcelClick(true);
      setExcelList(excelRows);
		} catch(error) {
			console.log("UserActionList - getExcelData - error :: ", error);
		} finally {
			setLoading(false);
		}
  };

	const columns = [
		{
			field: 'user_id',
			headerName: '사용자아이디',
			minWidth: 340,
			flex: 2,
		},
		// {
		// 	field: 'name',
		// 	headerName: '이름',
		// 	minWidth: 150,
		// 	flex: 0.5,
		// },
		{
			field: 'action',
			headerName: '작업내역',
			minWidth: 200,
			flex: 1,
		},
		{
			field: 'created',
			headerName: '작업일자',
			width: 160,
			flex: 1,
		},
	];

	const options = [
		{ 
			value: 'none',
			item: '검색할 항목 선택',
		},
		{ 
			value: 'user_id',
			item: '사용자아이디',
		},
		{ 
			value: 'action',
			item: '작업내역',
		},
	];

	const getUserActionList = async (limit, page, containData, startTime, endTime) => {
		if (startTime !== null && endTime !== null) {
			params = `limit=${limit}&offset=${limit*page}&contains=${JSON.stringify(containData)}&stime=${startTime}&etime=${endTime}`;
		} else {
			params = `limit=${limit}&offset=${limit*page}&contains=${JSON.stringify(containData)}`;
		}

		try {
			setLoading(true);
			const userActionList = await ApiService.getUserAction(params);

			//엑셀 출력 시 전체 리스트를 조회해야하기 때문에
			if(JSON.stringify(containData) === '{}' && (startTime === null && endTime === null)) {
				setTotalLength(userActionList.data.total);
			}

			const rows = userActionList.data.datas.map((data) => {
				data.created = dateFormat(new Date(data.created))
				data.name = data.body.name;
				return data;
			})

			setRowData(rows);
			setRowCount(userActionList.data.total);
		} catch(error) {
			console.log('UserActionList - getUserActionList - error :: ', error);
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		//작업일자 검색할 경우
		if((startDate !== null) && (endDate !== null)) {
			let startTime = Math.floor(new Date(startDate + " 00:00:00") / 1000);
			let endTime = Math.floor(new Date(endDate + " 23:59:59") / 1000);
			getUserActionList(paginationModel.pageSize, paginationModel.page, containData, startTime, endTime);
		} else {
			getUserActionList(paginationModel.pageSize, paginationModel.page, containData, null, null);
		}
	}, [paginationModel.page, containData, startDate, endDate])

	const getData = (selectValue, inputValue, start, end) => {
		const firstDate = moment(start);
		const secondDate = moment(end);
		const diffDay = moment.duration(secondDate.diff(firstDate)).asDays();

		if ((selectValue === "none") && (inputValue !== "")) {
			setOpenWarning(true);
			setErrorMsg('검색할 항목을 선택하세요!');
		} else {
			if(((start === null) && (end !== null)) || ((start !== null) && (end === null)) || (diffDay < 0)) {
				setOpenWarning(true);
				setErrorMsg('정확한 기간을 선택해주세요.');
			} else if(diffDay > 30) {
				setOpenWarning(true);
				setErrorMsg('조회 기간을 1개월(30일) 단위로 설정해주세요.');
			} else {
				setStartDate(start);
				setEndDate(end);
     
				if(inputValue === "") {
					setContainData({})
				} else {
					setContainData({ [selectValue]: inputValue.trim() })
				}
			}
		} 

	}

	return (
    <div className="containList">
      <BreadCrumbBar menu="이력 관리" smenu="사용자 이력 조회" />

      <div className="containItem">
        <div className="excelBtn" onClick={getExcelData}>
          <ExportExcel
            excelClick={excelClick}
            header={xlsxHeader}
            excelData={excelList}
            fileName={xlsxFileName}
          />
        </div>
        <SearchBar options={options} getData={getData} calendar={true} />
      </div>
      <div className="gridItem">
        {loading && (
          <CircularProgress
            sx={{ position: "absolute", top: "50%", left: "50%" }}
          />
        )}
        <DataGrid
          sx={{
            ".MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
          }}
          rows={rowData}
          columns={columns}
          columnHeaderHeight={35}
          rowHeight={23}
          autoHeight={true}
          paginationMode="server"
          pageSizeOptions={[paginationModel.pageSize]}
          rowCount={rowCount}
          onPaginationModelChange={setPaginationModel}
          paginationModel={paginationModel}
          disableColumnMenu={true}
          disableSelectionOnClick
        />
      </div>

      <Warning
        open={openWarning}
        onHideWarning={closeWarning}
        warningMsg={errorMsg}
      ></Warning>
    </div>
  );
}
